import React, {useState, useMemo, useEffect} from "react";
import { Rating } from 'react-simple-star-rating'
import productsliderimg from '../../src/assets/images/productsliderimg.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';
import {
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AgGridReact } from "@ag-grid-community/react";
  import "@ag-grid-community/styles/ag-grid.css";
  import "@ag-grid-community/styles/ag-theme-quartz.css";
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import gridboxicon from '../assets/images/gridboxicon.svg';
  import gridlisticon from '../assets/images/gridlisticon.svg';
  import exportsvg from '../assets/images/dashboard/export.svg';
  import filtersvg from '../assets/images/filter.svg';
  import customer_table from '../assets/images/customer_table.svg';
  import customer_edit from '../assets/images/customer_edit.svg';
  import customer_delete from '../assets/images/customer_trash.svg';
  import { useDispatch, useSelector } from 'react-redux';
  import { useNavigate } from 'react-router-dom';
  import axios from 'axios';
import { apiUrl } from "../config/Config";

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

const InternalUsers = () => {
    const [orderdata, setorderdata] = useState([
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Manager',accessLevel: 'admin', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Manager',accessLevel: 'admin', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Executive',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Manager',accessLevel: 'admin', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Executive',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Executive',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Manager',accessLevel: 'admin', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Manager',accessLevel: 'admin', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Executive',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'},
       {name: 'Robert Fox', email: 'robert@gmail.com',designation: 'Employee',accessLevel: 'user', phoneNumber: '(201) 555-0124',lastLogin: '6 April 2023', created: '6 April 2023'}
    ])
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);
  const [rowData, setRowData] = useState([]);
  const [showloding, setshowloding] = useState(false);
  
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState();

  const defaultColDef = {
    flex: 1,
  };
  let navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);

  const handleviewdetails = (id) => {
    // console.log('id >>', id)
    navigate('/update-user', { state: { userid: id } });
  }

  const dispatch = useDispatch();

  const handleCheckboxChange = async(t, id) => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updateinternaluserstatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        handlefetchdata();
        setshowloding(false);
      } else {
        if(res.data.message == 'invalid user') {
          dispatch({ type: "userdata", payload: {} })
          navigate('/login');
        } else {
          alert(res.data.message);
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
  }

  const handlefetchdata = async() => {
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    let resp = await axios
        .get(apiUrl + "getallaccounts", headers)
        .then((res) => {
          // console.log('res >>', res.data)
          if(res.data.status == 'success') {
            var prevdata = res?.data?.data;
    if(prevdata?.length > 0) {
      var columnsarr = [];
      var hidecolumns = ['userid', 'updated_at','created_at', 'status'];
      var hidefilters = [];
      var columns = Object.keys(prevdata[0]);
      for(var i = 0; i < columns?.length;i++) {
        if(!hidecolumns.includes(columns[i])) {
            if (columns[i] == "name") {
                var obj = {};
          obj.field = columns[i];
          obj.cellStyle = {color: '#000', fontWeight: 600}
          
          obj.cellClass = 'inventorycell';
          obj.filter = true;
          obj.filterParams = {
            filterOptions: ["contains"],
            maxNumConditions: 1,
          }
          obj.width = 250;
          obj.cellRenderer = (props) => {
            return (
              <div className="d-flex" style={{marginTop: 3}}>
                {/* <img src={customer_table} className="customerrowimage" /> */}
                <div className="customernamediv">
                    <p>{props?.data?.name} <br /><span className="customerrowemail">{props?.data?.email}</span></p>
                </div>
                
              </div>
              
            )
            
          }
        //   console.log('obj >>', obj)
          columnsarr.push(obj);


            } else {
              var obj = {};
              obj.field = columns[i];
              obj.cellStyle = { color: "#000", fontWeight: 600 };
              if (!hidefilters.includes(columns[i])) {
                obj.cellClass = 'inventorycell';
                obj.filter = true;
                obj.filterParams = {
                  filterOptions: ["contains"],
                  maxNumConditions: 1,
                };
              }
              //   console.log('obj >>', obj)
              columnsarr.push(obj);
            }
          
        }
      }

      //action
      var statusobj = {
        field: "status",
        headerName: "Status",
        cellRenderer: (props) => {
          // console.log('props >>', props?.data)
          return (
            <div className="d-flex">
              <div class="form-check">
                <input
                onChange={(t) => {handleCheckboxChange(t, props?.data?.userid)}}
                  type="checkbox"
                  class="form-check-input tableformcheck"
                  id="check1"
                  name="option1"
                  value="something"
                  checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
                />
              </div>
            </div>
          );
        },
      };
      columnsarr.push(statusobj);

      //action
      var actionobj = 
      {
        field: "action",
        headerName: "Action",
        cellRenderer: (props) => {
        // console.log('props >>', props?.data)
          return (
            <div className="d-flex">
                <div className="customet_table_icon_div" onClick={() => {handleviewdetails(props?.data?.userid)}}>
                    <img src={customer_edit} className="customet_table_icon" />
                </div>
                {/* <div className="customet_table_icon_div">
                    <img src={customer_delete} className="customet_table_icon" />
                </div> */}
            </div>
          )
        },
      }
      columnsarr.push(actionobj);


      setColDefs(columnsarr);
      setRowData(prevdata);
  }
          } else {
            if(res.data.message == 'invalid user') {
              dispatch({ type: "userdata", payload: {} })
              navigate('/login');
            } else {
              alert(res.data.message);
            }
          }
        }).catch((err) => {
          alert(err.message)
      })

    
  setshowloding(false);
}

const newproductclick = () => {
  navigate('/add-internal-user')
}

  useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
          //   fetchdata();
          if(userdata?.type == "superadmin") {
            handlefetchdata()
          } else {
            navigate("/dashboard");
          }
         
          
        } else {
          navigate("/login");
        }
      }, []);

    return (
      <div className="">
        <div className="dashboardbox" style={{width: '100%'}}>
        <div className="productstogglebar mt-2">
           
            <div className="filterdiv couponfilterdiv" onClick={newproductclick}>
                <FontAwesomeIcon icon={faPlus} className="iconstyles" style={{color: '#64748B'}} />
                <p>Add User</p>
            </div>
          </div>
        <div
        className={"ag-theme-quartz mt-4"}
        style={{ width: "100%", height: 550 }}
      >
        <AgGridReact
          // modules={AllModules}
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          suppressRowClickSelection={true}
          groupSelectsChildren={true}
          rowSelection={"multiple"}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={paginationPageSizeSelector}
          rowHeight={50}
          // onGridReady={onGridReady}
        />
      </div>
        </div>
        
        

        
      </div>
    );
}

export default InternalUsers;